<template>    
    <BaseModal
        :id="'static-confirmation-default-tasks'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_local()">
                
                <div class="p-0 formdynamic__item col-md-12" :style="`margin-top:20px`">
                    <div  id="1">
                        <label style="display: block" v-html="`1. Do you want to add the default daily task?`" class="modal-label mb-3 " for="1"/>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="1yes"
                                :value="true"
                                v-model="add_daily_tasks"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text'" v-html="'Yes'"
                                for="1yes"
                            />
                        </div>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="1not"
                                :value="false"
                                v-model="add_daily_tasks"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text '" v-html="'No'"
                                for="1not"
                            />
                        </div>
                    </div>
                </div>
                <div class="p-0 formdynamic__item col-md-12" :style="`margin-top:20px`">
                    <div class="" id="1">
                        <label style="display: block" v-html="`2. Do you want to add the default project tasks?`" class="modal-label mb-3" for="1"/>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="2yes"
                                :value="true"
                                v-model="add_project_tasks"
                                style="display: inline"
                            />
                            <label
                            :class="'form-check-label radiobutton__text'" v-html="'Yes'"
                            style="font-size: 0.9rem"
                                for="2yes"
                            />
                        </div>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="2not"
                                :value="false"
                                v-model="add_project_tasks"
                                style="display: inline"
                            />
                            <label
                            :class="'form-check-label radiobutton__text'" style="font-size: 0.9rem" v-html="'No'"
                            for="2not"
                            />
                        </div>
                    </div>
                </div>
                <CentralLiteButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'
import CentralLiteButtons       from    '@/components/CentralLiteButtons'

export default {

    name:   'ConfirmationModalDefaultTasks',

    props: [
        'title',
        'breadcrumb',
    ],

    components:{
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data(){
        return{
            add_daily_tasks: true,
            add_project_tasks: true
        }
    },

    mounted()
    {
    },

   
    methods:{
        form_submit_local()
        {
            window.$('#static-confirmation-default-tasks').modal('hide')
            this.$emit('upload', {add_daily_tasks: this.add_daily_tasks, add_project_tasks: this.add_project_tasks})
        }
      

    },

    
}
</script>